import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import { fetchData, updateData, postData, deleteData } from '../../apiService';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PaymentIcon from '@mui/icons-material/Payment';
import PrintIcon from '@mui/icons-material/Print';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CopyrightIcon from '@mui/icons-material/Copyright';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { Button, Dialog, DialogTitle, DialogContent, Grid, Card, CardActionArea, CardContent, Typography, Box } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StorageIcon from '@mui/icons-material/Storage';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Modal, TextField } from "@mui/material";
import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { CircularProgress } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from "@mui/icons-material/Close";
import Select from 'react-select'; // Import react-select
import PreviewIcon from '@mui/icons-material/Preview';
import LockClockIcon from '@mui/icons-material/LockClock';
import BrowseGalleryIcon from '@mui/icons-material/BrowseGallery';
import HourglassDisabledIcon from '@mui/icons-material/HourglassDisabled';
import RunCircleOutlinedIcon from '@mui/icons-material/RunCircleOutlined';

const generateCalendar = (year, month) => {
  const firstDay = new Date(year, month, 1).getDay(); // 0 = Sunday
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const weeks = [];
  let dayCounter = 1 - firstDay;

  for (let week = 0; week < 6; week++) {
    const weekDays = [];
    for (let d = 0; d < 7; d++) {
      if (dayCounter > 0 && dayCounter <= daysInMonth) {
        weekDays.push(dayCounter);
      } else {
        weekDays.push(null);
      }
      dayCounter++;
    }
    weeks.push(weekDays);
  }

  return weeks;
};

const Home = () => {
  const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) logout();
    fetchtableData();
    fetchShifttableData();
    fetchEmployeeTableData();
    setFromDate(getFormattedStartDate());
    setToDate(getFormattedCurrentDate());
    fetchDepartmentListData();
    const [year, month] = selectedMonth.split('-').map(Number);
    const dates = getMonthDates(year, month - 1);
    setCurrentMonthDates(dates);
  }, [isAuthenticated, token, logout, id]);

  // Get Total Employees
  const [employeeData, setEmployeeData] = useState([]);
  const [totalemployeecount, setTotalEmployeeCount] = useState([]);
  const fetchEmployeeTableData = async () => {
    setLoading(true);
    fetchData('EmployeeApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setEmployeeData(response.response_data);
          setTotalEmployeeCount(response.response_data.length);
        }
      })
      .catch((error) => {
        console.error('Error fetching Employee Details:', error);
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

  // open employee details 
  const [openEmployeeModal, setOpenEmployeeModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');

  // 🔸 Filter employees by Name or Code
  const filteredEmployees = employeeData.filter((emp) => {
    const search = searchTerm.toLowerCase();
    return (
      emp.EmployeeName.toLowerCase().includes(search) ||
      emp.EmployeeCode.toLowerCase().includes(search)
    );
  });

  const handleCloseEmployeeModal = () => {
    setSearchTerm('');
    setOpenEmployeeModal(false);
  };

  //-----------------Punch Modals starts------------------
  // Punch In Section
  const [openPunchModal, setOpenPunchModal] = useState(false);
  const handleClosePunchModal = () => setOpenPunchModal(false);
  const handleOpenPunchModal = () => {
    setSearchTerm1('');
    setOpenPunchModal(true);
    fetchPunchInTableData();
  };

  // Punch Out Section
  const [openPunchOutModal, setOpenPunchOutModal] = useState(false);
  const handleClosePunchOutModal = () => setOpenPunchOutModal(false);
  const handleOpenPunchOutModal = () => {
    setSearchTerm2('');
    setOpenPunchOutModal(true);
    fetchPunchOutTableData();
  };

  // Punch Not Started Section
  const [openNotstartedModal, setOpenNotStartedModal] = useState(false);
  const handleCloseNotStartedModal = () => setOpenNotStartedModal(false);
  const handleOpenNotStartedModal = () => {
    setSearchTerm3('');
    setOpenNotStartedModal(true);
    fetchPunchOutTableData();
  };

  //-----------------Punch Modals End------------------
  // Today Activities Items
  const todayactivityCards = [
    {
      title: 'Total Employees',
      icon: (
        <div
          onClick={() => setOpenEmployeeModal(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer',
          }}
        >
          <PeopleAltIcon style={{ color: '#e0e1f0ff', fontSize: '20px' }} />
          <span style={{ fontWeight: 'bold' }}>{totalemployeecount}</span>
        </div>
      ),
    },
    { title: 'Not Yet Started', icon: <HourglassDisabledIcon onClick={handleOpenNotStartedModal} /> },
    { title: 'Punch In', icon: <LockClockIcon onClick={handleOpenPunchModal} /> },
    { title: 'Punch Out', icon: <BrowseGalleryIcon onClick={handleOpenPunchOutModal} /> },
  ];

  //-----------------*PUNCH IN / OUT / NOT PUNCHS FUNCTIONS STARTS*------------------
  //-----------------PunchIn Details (Current Date)---------------------
  const [punchinData, setPunchInData] = useState([]);
  const fetchPunchInTableData = async () => {
    setLoading(true);
    try {
      // Temporary: using a fake date for testing instead of the actual 'toDate'
      const FaketoDate = '2025-08-31';

      // API call using your custom fetchData utility
      const response = await fetchData(
        'DashboardApi',
        `/PunchInDetails/${companyId}/${formatDate1(FaketoDate)}`, //{formatDate1(toDate)}
        token
      );

      // If the API response is successful, store data in state
      if (response.responseCode === '1111') {
        setPunchInData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching PunchIn Customer Details:', error);

      // Handle 401 (unauthorized) - force logout and redirect to login page
      if (error.response && error.response.status === 401) {
        logout();
        history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      }
    }
    finally {
      setLoading(false); // Hide loading screen
    };
  };

  useEffect(() => {
    fetchPunchInTableData();
  }, []);

  const [searchTerm1, setSearchTerm1] = useState('');

  // 🔸 Filter employees by Name or Code
  const filteredPunchins = punchinData.filter((emp) => {
    const search = searchTerm1.toLowerCase();
    return (
      emp.EmployeeName.toLowerCase().includes(search) ||
      emp.EmployeeCode.toLowerCase().includes(search)
    );
  });

  //-----------------PunchOut Details (Current Date)---------------------
  const [punchoutData, setPunchOutData] = useState([]);
  const fetchPunchOutTableData = async () => {
    setLoading(true);
    try {
      // Temporary: using a fake date for testing instead of the actual 'toDate'
      const FaketoDate = '2025-08-31';

      // API call using your custom fetchData utility
      const response = await fetchData(
        'DashboardApi',
        `/PunchOutDetails/${companyId}/${formatDate1(FaketoDate)}`, //{formatDate1(toDate)}
        token
      );

      // If the API response is successful, store data in state
      if (response.responseCode === '1111') {
        setPunchOutData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching PunchOut Customer Details:', error);

      // Handle 401 (unauthorized) - force logout and redirect to login page
      if (error.response && error.response.status === 401) {
        logout();
        history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      }
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPunchOutTableData();
  }, []);

  const [searchTerm2, setSearchTerm2] = useState('');

  // 🔸 Filter employees by Name or Code
  const filteredPunchouts = punchoutData.filter((emp) => {
    const search = searchTerm2.toLowerCase();
    return (
      emp.EmployeeName.toLowerCase().includes(search) ||
      emp.EmployeeCode.toLowerCase().includes(search)
    );
  });

  //-----------------Not Started Details (Current Date)---------------------
  const [notStartedData, setNotStartedData] = useState([]);
  const fetchNotStartedTableData = async () => {
    try {
      // Temporary: using a fake date for testing instead of the actual 'toDate'
      const FaketoDate = '2025-08-31';

      // API call using your custom fetchData utility
      const response = await fetchData(
        'DashboardApi',
        `/NotYetStartedDetails/${companyId}/${formatDate1(FaketoDate)}`, //{formatDate1(toDate)}
        token
      );

      // If the API response is successful, store data in state
      if (response.responseCode === '1111') {
        setNotStartedData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching PunchOut Customer Details:', error);

      // Handle 401 (unauthorized) - force logout and redirect to login page
      if (error.response && error.response.status === 401) {
        logout();
        history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      }
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotStartedTableData();
  }, []);

  const [searchTerm3, setSearchTerm3] = useState('');

  // 🔸 Filter employees by Name or Code
  const filteredNotStarted = notStartedData.filter((emp) => {
    const search = searchTerm3.toLowerCase();
    return (
      emp.EmployeeName.toLowerCase().includes(search) ||
      emp.EmployeeCode.toLowerCase().includes(search)
    );
  });

  // 👇 Inside your React component
  const [displayMonthYear, setDisplayMonthYear] = useState('');

  useEffect(() => {
    if (notStartedData.length > 0) {
      // Get the latest AttendanceDate
      const latestDate = notStartedData
        .map(item => new Date(item.AttendanceDate))
        .sort((a, b) => b - a)[0];

      // Format month & year
      const options = { year: 'numeric', month: 'long' };
      const formatted = latestDate.toLocaleDateString('en-US', options);

      setDisplayMonthYear(formatted); // e.g., "September 2025"
    } else {
      setDisplayMonthYear('');
    }
  }, [notStartedData]);

  //-----------------*PUNCH IN / OUT / NOT PUNCHS FUNCTIONS ENDS*-----------
  //------------------------------------------------------------------------
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const weeks = generateCalendar(currentYear, currentMonth);

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else setCurrentMonth(currentMonth - 1);
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else setCurrentMonth(currentMonth + 1);
  };

  const isToday = (day) => {
    const today = new Date();
    return day === today.getDate() &&
      currentMonth === today.getMonth() &&
      currentYear === today.getFullYear();
  };

  const isSelected = (day) => {
    return day === selectedDate.getDate() &&
      currentMonth === selectedDate.getMonth() &&
      currentYear === selectedDate.getFullYear();
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onBatchSettings = () => {
    setOpen(true);
    setOpenBataModal(true);
  };

  const onShiftChanges = () => {
    // TODO: replace with your real navigation / handler
    console.log('Shift Changes clicked');
    handleClose();
  };

  // Bata Settings Data Load 
  const [openBataModal, setOpenBataModal] = useState(false);
  const [bataData, setBataData] = useState([]);
  const fetchtableData = async () => {
    setLoading(true);
    fetchData('BataSettingApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setBataData(response.response_data);
        }
        console.log(response);
      })
      .catch((error) => {
        console.error('Error fetching Department:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

  // Bata expand section
  const [expandedDepartments, setExpandedDepartments] = React.useState({});
  const [expandedDesignations, setExpandedDesignations] = React.useState({});

  const toggleDepartment = (department) => {
    setExpandedDepartments((prev) => ({
      ...prev,
      [department]: !prev[department],
    }));
  };

  const toggleDesignation = (department, designation) => {
    setExpandedDesignations((prev) => ({
      ...prev,
      [`${department}-${designation}`]: !prev[`${department}-${designation}`],
    }));

  };

  // Preprocess data into grouped structure
  const groupedData = bataData.reduce((acc, item) => {
    if (!acc[item.DepartmentName]) acc[item.DepartmentName] = {};
    if (!acc[item.DepartmentName][item.DesignationName]) acc[item.DepartmentName][item.DesignationName] = [];
    acc[item.DepartmentName][item.DesignationName].push(item);
    return acc;
  }, {});

  let globalSerial = 1;

  const formatTimeSpan = (timeSpan) => {
    if (!timeSpan) return "-";

    const [hoursStr, minutesStr] = timeSpan.split(":");
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    if (isNaN(hours) || isNaN(minutes)) return "-";

    const period = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;

    // If minutes are 00, show just the hour (e.g. "9 AM")
    return minutes === 0 ? `${hour12} ${period}` : `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  // Bata Create 
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleOpenBataModal = () => setOpenBataModal(true);
  const handleCloseBataModal = () => setOpenBataModal(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  const modalStyle = {
    backgroundColor: "#0B132B",
    color: "#FFD700",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px",
    maxWidth: 600,
    width: "95%",
    margin: "auto",
    marginTop: "8%",
    border: "2px solid #FFD700",
  };

  const smallModalStyle = {
    backgroundColor: "#0B132B",
    color: "#FFD700",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px",
    maxWidth: 400,
    width: "95%",
    margin: "auto",
    marginTop: "10%",
    border: "2px solid #FFD700",
  };

  const [formData, setFormData] = useState({
    CompanyId: companyId,
    CreatedBy: userId,
    CreatedDate: new Date().toISOString(),
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    setFormData(updatedFormData);
  };

  const submitData = async () => {
    try {
      // Update UpdatedBy field in each selected item
      const updatedItems = selectedItems.map(item => ({
        ...item,
        CreatedBy: userId, // assuming userId is defined in your scope
      }));

      // Submit data
      const response = await postData('BataSettingApi', updatedItems, token);
      console.log('Data Created successfully:', response);

      history.push('/BataSettingsIndex');
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again.');
    }
  };

  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [dropdownDepartmentOptions, setDropdownDepartmentOptions] = useState([]);

  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [dropdownDesignationOptions, setDropdownDesignationOptions] = useState([]);

  useEffect(() => {
    fetchDropdownDepartmentOptions();
    fetchDropdownDesignationOptions();
  }, []);

  const fetchDropdownDepartmentOptions = () => {
    fetchData('DepartmentApi', `/${companyId}`, token)
      .then((response) => response.response_data)
      .then((data) => {
        setDropdownDepartmentOptions(data);
      })
      .catch((error) => {
        console.error('Error fetching Department dropdown options:', error);
      });
  };

  const fetchDropdownDesignationOptions = () => {
    fetchData('DesignationApi', `/${companyId}`, token)
      .then((response) => response.response_data)
      .then((data) => {
        setDropdownDesignationOptions(data);
      })
      .catch((error) => {
        console.error('Error fetching Designation dropdown options:', error);
      });
  };

  const [selectedItems, setSelectedItems] = useState([]);
  //handle search [ITEM SEARCH]
  const [isFocused, setIsFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);

  const filteredData = selectedItems.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const handleCalculation = (e, index, inputType) => {
    let name, value;

    // ✅ Determine input name and value (from event or direct call)
    if (typeof e === "object" && e?.target) {
      name = e.target.name;
      value = parseFloat(e.target.value) || 0;
    } else {
      name = inputType;
      value = parseFloat(e) || 0;
    }

    setSelectedItems((prevDetails) => {
      const updatedDetails = [...prevDetails];

      // ✅ Clone the current row/item safely
      const currentItem = { ...updatedDetails[index] };

      // ✅ Update the changed field
      currentItem[name] = value;

      // ✅ Update array with modified item
      updatedDetails[index] = currentItem;

      return updatedDetails;
    });
  };

  // ✅ Fetch slab details function
  const fetchSlabDetails = async (departmentId, designationId) => {
    try {
      if (!departmentId || !designationId) return;

      const response = await fetchData('BataSettingApi', `/BataSlab/${companyId}/${departmentId}/${designationId}`, token);
      if (response.responseCode === '1111') {
        const data = await response.response_data;
        // ✅ Store the data
        setSelectedItems(data);

      } else {
        console.error('Unexpected response code:', response.responseCode);
        return [];
      }

    } catch (error) {
      console.error("Error fetching slab details:", error);
    }
  };

  // ✅ Auto-fetch when both dropdowns are selected
  useEffect(() => {
    if (selectedDepartment && selectedDesignation) {
      fetchSlabDetails(selectedDepartment, selectedDesignation);
    }
  }, [selectedDepartment, selectedDesignation]);

  // Shift Settings 
  const [shiftData, setShiftData] = useState([]);

  const fetchShifttableData = async () => {
    setLoading(true);
    fetchData('ShiftApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setShiftData(response.response_data);
        }
        console.log(response);
      })
      .catch((error) => {
        console.error('Error fetching Shift:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

  const modalStyleShift = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    bgcolor: "#0B132B", // dark background
    borderRadius: 3,
    boxShadow: 24,
    p: 2,
    color: "#aa3c4eff", // baby pink text
    maxHeight: "90vh",
    overflowY: "auto",
  };

  const [shiftModalOpen, setShiftModalOpen] = useState(false);
  const handleOpenShiftModal = () => setShiftModalOpen(true);
  const handleCloseShiftModal = () => setShiftModalOpen(false);
  const [errorMessageEdit, setErrorMessageEdit] = useState("");
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const openDetailModal = async (id) => {
    try {
      const response = await fetchData('ShiftApi', `/ShiftDetails/${id}`, token);

      if (response.responseCode === '1111' && response.response_data) {
        const data = response.response_data;

        // 🕒 Convert "HH:mm:ss" to "HH:mm" for the input fields
        const formattedData = {
          ...data,
          PunchInTime: data.PunchInTime ? data.PunchInTime.slice(0, 5) : "",
          PunchOutTime: data.PunchOutTime ? data.PunchOutTime.slice(0, 5) : "",
        };

        setUpdateData(formattedData);
        setIsDetailModalOpen(true);
      }
    } catch (error) {
      console.error('Error fetching Shift:', error);
    }
  };

  const toggleModalBranch = () => {
    setIsDetailModalOpen(false); // Step 2
  };

  const handleUpdateInputChange = (event) => {
    const { name, value } = event.target;
    setUpdateData((prevDataItem) => ({
      ...prevDataItem,
      [name]: value,
    }));
  };

  const [updatedData, setUpdateData] = useState({});

  const updateRecord = async (event) => {
    event.preventDefault();

    if (!updatedData.Name) {
      setErrorMessageEdit('Name is required !');
      setIsLoading(false);
      return;
    }

    const formatTime = (time) => {
      if (!time) return null;
      const parts = time.split(':');
      if (parts.length === 2) {
        // If time is in HH:mm format — add seconds
        return `${time}:00`;
      } else if (parts.length === 3) {
        // Already in HH:mm:ss format — return as is
        return time;
      }
      return null; // fallback if format is unexpected
    };

    const workShift = {
      CompanyId: companyId,
      Id: updatedData.Id,
      Name: updatedData.Name,
      PunchInTime: formatTime(updatedData.PunchInTime),
      PunchOutTime: formatTime(updatedData.PunchOutTime),
      CreatedDate: updatedData.CreatedDate,
      CreatedBy: updatedData.CreatedBy,
      UpdatedBy: userId,
      UpdatedDate: new Date(),
    };

    try {
      await updateData('ShiftApi', `${updatedData.Id}`, workShift, token);

      // Reset form data
      setUpdateData({
        CompanyId: companyId,
        Name: '',
        PunchInTime: '',
        PunchOutTime: '',
      });

      setIsDetailModalOpen(false);
      fetchShifttableData(); // refresh table after update ✅
    } catch (error) {
      console.error('Error updating record:', error);
    }
  };

  // Help Center Details Modal 
  const [helpOpen, setHelpOpen] = useState(false);

  const handlehelpOpen = () => setHelpOpen(true);
  const handlehelpClose = () => setHelpOpen(false);

  // Right Section Calendar 

  // From & To Date Section Change
  const handleFromDateChange = (e) => {
    const selectedDate = e.target.value;
    setFromDate(selectedDate);
  };

  const handleToDateChange = (e) => {
    const selectedDate = e.target.value;
    setToDate(selectedDate);
  };

  const getFormattedCurrentDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().split('T')[0];
  };

  const getFormattedStartDate = () => {
    const monthStartDate = new Date();
    monthStartDate.setDate(1);
    return monthStartDate.toISOString().split('T')[0];
  };

  // Employee Dropdown 
  const [employeedropOptions, setEmployeeDropOptions] = useState([]);
  const [selectedEmployeeType, setSelectedEmployeeType] = useState("");

  const fetchEmployeeType = async () => {
    try {
      const response = await fetchData('EmployeeApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(category => ({
          value: category.Id,
          label: category.EmployeeCode + '-' + category.EmployeeName
        }));
        setEmployeeDropOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Employee:', error);
    }
  };

  const handleEmployeeTypeChange = (selectedOption) => {
    setSelectedEmployeeType(selectedOption);
  };

  useEffect(() => {
    fetchEmployeeType();
  }, []);

  // Selected Employee Attendance
  const [employeeattendance, setEmployeeAttendance] = useState([]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const formatDate1 = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0'); // 0-indexed month
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const [currentMonth1, setCurrentMonth1] = useState(new Date().getMonth());
  const [currentYear1, setCurrentYear1] = useState(new Date().getFullYear());

  const monthLabel = new Date(currentYear1, currentMonth1).toLocaleString('default', {
    month: 'short',
    year: 'numeric',
  });

  const prevMonth = () => {
    setCurrentMonth1(prev => {
      if (prev === 0) {
        setCurrentYear1(y => y - 1);
        return 11;
      }
      return prev - 1;
    });
  };

  const nextMonth = () => {
    setCurrentMonth1(prev => {
      if (prev === 11) {
        setCurrentYear1(y => y + 1);
        return 0;
      }
      return prev + 1;
    });
  };

  // 📅 Generate calendar structure for current month
  const [selectedDate1, setSelectedDate1] = useState(new Date());
  const getCalendar1 = (year, month) => {
    const weeks = [];
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDay = firstDay.getDay(); // 0 (Sun) to 6 (Sat)
    const totalDays = lastDay.getDate();

    let day = 1 - startDay;
    for (let w = 0; w < 6; w++) {
      const week = [];
      for (let d = 0; d < 7; d++) {
        if (day < 1 || day > totalDays) {
          week.push({ day: null }); // empty cell
        } else {
          week.push({ day });
        }
        day++;
      }
      weeks.push(week);
    }
    return { year, month, weeks };
  };

  const calendar1 = getCalendar1(currentYear1, currentMonth1);

  useEffect(() => {
    // Start of the month
    const start = new Date(currentYear1, currentMonth1, 1);
    // End of the month
    const end = new Date(currentYear1, currentMonth1 + 1, 0);

    setFromDate(start);
    setToDate(end);
  }, [currentMonth1, currentYear1]);

  const fetchEmployeAttendancetableData = async () => {
    const empid = selectedEmployeeType?.value;
    if (empid && empid != 0) {
      setEmployeeAttendance([]);
      try {
        const response = await fetchData(
          'AttendanceApi',
          `/AttendanceDetails/${companyId}/${empid}/${formatDate1(fromDate)}/${formatDate1(toDate)}`,
          token
        );
        if (response.responseCode === '1111') {
          setEmployeeAttendance(response.response_data);
        }
      } catch (error) {
        console.error('Error fetching Customer Details:', error);
        if (error.response && error.response.status === 401) {
          logout();
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      }
    }
  };

  function formatDate(dateString) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
    return formattedDate;
  }

  // Define colors for each attendance status
  const attendanceColors = {
    P: '#90EE90',   // light green
    HLF: '#FFD700', // yellow
    A: '#FF7F7F',    // light red
    MIS: '#FF4C4C',   // red
  };

  // Build an easy lookup object from employeeattendance
  const attendanceMap = useMemo(() => {
    const map = {};
    employeeattendance.forEach(item => {
      const date = new Date(item.AttendanceDate);
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      map[`${year}-${month}-${day}`] = item.statusName;
    });
    return map;
  }, [employeeattendance]);

  const StatusPill = ({ title, value, color }) => (
    <div
      style={{
        backgroundColor: color,
        color: '#000',
        padding: '5px 10px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      }}
    >
      <span>{title}</span>
      <span>{value}</span>
    </div>
  );

  // 🟢 1. Theme object
  const themes = {
    dark: {
      pageBg: '#0B132B',
      cardBg: '#1E1E2F',
      text: '#FFFFFF',
      accent: '#90caf9',
      buttonBg: '#1976d2',
      selectBorder: '#90caf9',
      pillText: '#000',
    },
    light: {
      pageBg: '#f5f5f5',
      cardBg: '#FFFFFF',
      text: '#333',
      accent: '#1976d2',
      buttonBg: '#1976d2',
      selectBorder: '#1976d2',
      pillText: '#fff',
    },
  };

  const [themeMode, setThemeMode] = useState('dark'); // switch between 'light' & 'dark'
  const theme = themes[themeMode];
  const lightTheme = {
    cardBg: '#ffffff',
    text: '#1e1e1e',
    accent: '#1976d2',     // blue accent for headers
    buttonBg: '#1976d2'
  }

  const darkTheme = {
    background: '#121417',
    cardBg: '#1E2A38',
    accent: '#4ADE80',
    text: '#E0E0E0',
    todayBg: '#4ADE80',
    todayText: '#121417',
    otherDayBg: '#2A3748',
  };

  // Selected Day Details when click on calendar 
  const [openselectedDaymodal, setSelectedDayModal] = React.useState(false);
  //const handleSelectedDayModalOpen = () => setSelectedDayModal(true);
  //const handleSelectedDayModalClose = () => setSelectedDayModal(false);
  const [daySummary, setDaySummary] = useState({
    PunchInCount: 0,
    PunchOutCount: 0,
    NotPunchedYetCount: 0,
    TotalEmployees: 0,
  });

  // Fetch data for selected day
  const fetchDaySummaryTableData = async (date) => {
    if (!date) return;

    try {
      const formattedDate = date.toISOString().split("T")[0]; // YYYY-MM-DD
      const response = await fetchData(
        "DashboardApi",
        `/SelectedDayDetails/${companyId}/${formattedDate}`,
        token
      );

      if (response.responseCode === "1111" && response.response_data.length > 0) {
        setDaySummary(response.response_data[0]); // use first object
      } else {
        // fallback if empty
        setDaySummary({
          PunchInCount: 0,
          PunchOutCount: 0,
          NotPunchedYetCount: 0,
          TotalEmployees: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching day summary:", error);
    }
  };

  // Handle cell click
  const handleSelectedDayModalOpen = (date) => {
    setSelectedDate1(date);
    setSelectedDayModal(true);
    fetchDaySummaryTableData(date);
  };

  const handleSelectedDayModalClose = () => {
    setSelectedDayModal(false);
  };

  {/* Styles for cards and charts */ }
  const cardStyle = {
    background: '#3A3F50',
    padding: '20px',
    borderRadius: '15px',
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '16px',
  };

  const chartStyle = {
    background: '#3A3F50',
    flex: 1,
    minHeight: '370px',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
  };

  // Department List
  const [departmentListData, setDepartmentListData] = useState([]);

  const fetchDepartmentListData = async () => {
    setLoading(true);
    fetchData('DepartmentApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setDepartmentListData(response.response_data);
        }
        console.log(response);
      })
      .catch((error) => {
        console.error('Error fetching Department:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

  // Open Department data
  const [selectedDepartment1, setSelectedDepartment1] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const openDeptModal = (dept) => {
    setSelectedDepartment1(dept);
    setModalOpen(true);
  };

  const closeDeptModal = () => {
    setModalOpen(false);
    setSelectedDepartment1(null);
  };

  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    if (departmentListData.length === 0) return;
    setVisibleCount(0); // reset when list changes
    const interval = setInterval(() => {
      setVisibleCount((prev) => {
        if (prev < departmentListData.length) return prev + 1;
        clearInterval(interval);
        return prev;
      });
    }, 150); // delay between each button
    return () => clearInterval(interval);
  }, [departmentListData]);

  const handleCardClick = (dept) => {
    setSelectedDepartment1(dept); // store clicked department
    setModalOpen(true);            // open modal
    fetchDepWithDesandEmpData(dept.Id)
  };

  const [depwisedesgandempListData, setDepWiseDesignandEmpListData] = useState([]);
  // Fetch data for selected day
  const fetchDepWithDesandEmpData = async (id) => {
    if (!id) return;

    try {
      const response = await fetchData(
        "DashboardApi",
        `/Designation&customerByDepartment/${id}`,
        token
      );

      if (response.responseCode === "1111" && response.response_data.length > 0) {
        setDepWiseDesignandEmpListData(response.response_data); // use first object
      } else {
        // fallback if empty
        setDepWiseDesignandEmpListData({

        });
      }
    } catch (error) {
      console.error("Error fetching day summary:", error);
    }
  };

  // Bata expand section
  const [expandedDepartDes, setExpandedDepartDes] = React.useState({});
  const [expandedDesignations1, setExpandedDesignations1] = React.useState({});

  const toggleDepartment1 = (department) => {
    setExpandedDepartDes((prev) => ({
      ...prev,
      [department]: !prev[department],
    }));
  };

  const toggleDesignation1 = (department, designation) => {
    setExpandedDesignations1((prev) => ({
      ...prev,
      [`${department}-${designation}`]: !prev[`${department}-${designation}`],
    }));

  };

  // Preprocess data into grouped structure
  const groupedData1 = depwisedesgandempListData.reduce((acc, item) => {
    if (!acc[item.DepartmentName]) acc[item.DepartmentName] = {};
    if (!acc[item.DepartmentName][item.DesignationName]) acc[item.DepartmentName][item.DesignationName] = [];
    acc[item.DepartmentName][item.DesignationName].push(item);
    return acc;
  }, {});

  //-----------------------------Attendance Log [center coulunm bottom section]----------------------------
  const AttendanceLogCards = [
    {
      title: 'Attendance Cards',
      icon: (
        <div
          onClick={() => setOpenMonthlyAttendanceModal(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer',
          }}
        >
          <RunCircleOutlinedIcon style={{ color: 'yellow', fontSize: '25px' }} />
        </div>
      ),
    },
    { title: 'Not Yet Started', icon: <HourglassDisabledIcon onClick={handleOpenNotStartedModal} /> },
    { title: 'Punch In', icon: <LockClockIcon onClick={handleOpenPunchModal} /> },
    { title: 'Punch Out', icon: <BrowseGalleryIcon onClick={handleOpenPunchOutModal} /> },
  ];

  // Monthly Attendance Sheet 
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`; // YYYY-MM
  });

  // open employee details 
  const [openMonthlyAttendanceModal, setOpenMonthlyAttendanceModal] = useState(false);

  const [searchTermMonthlyAttendance, setSearchTermMonthlyAttendance] = useState('');
  const handleCloseMonthlyAttendanceModal = () => {
    setSearchTermMonthlyAttendance('');
    setOpenMonthlyAttendanceModal(false);
  };

  const [staffData, setStaffData] = useState([]);
  const [currentMonthDates, setCurrentMonthDates] = useState([]);

  const getMonthDates = (year, month) => {
    const dates = [];
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
      const dateStr = date.toLocaleDateString('en-CA'); // YYYY-MM-DD
      const dayLabel = `${String(day).padStart(2, '0')}-${dayName}`;
      dates.push({ date: dateStr, label: dayLabel });
    }

    return dates;
  };

  const statusShortCode = {
    P: 'P',
    A: 'A',
    HLF: 'HLF',
    MIS: 'MIS',
  };


  return (
    <div style={{ display: 'flex', flexDirection: 'row', fontFamily: 'Segoe UI', overflow: 'hidden' }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 50,
          }}
        >
          {/* Inline Diamond Loader */}
          <div
            style={{
              position: 'relative',
              width: '50px',
              height: '50px',
              backgroundColor: 'rgba(255,255,255,0.1)',
              transform: 'rotate(45deg)',
              overflow: 'hidden',
              borderRadius: '6px',
              boxShadow: '0 6px 18px rgba(255,255,255,0.2)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: '6px',
                margin: 'auto',
                background: '#ffffff',
                borderRadius: '4px',
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                inset: '-12px',
                margin: 'auto',
                background: '#52fad8ff',
                borderRadius: '6px',
                animation: 'diamondLoader 2s linear infinite',
              }}
            ></div>
            <style>
              {`
            @keyframes diamondLoader {
              0%,10% { transform: translate(-50px,-50px) rotate(-45deg); }
              90%,100% { transform: translate(0px,0px) rotate(-45deg); }
            }
          `}
            </style>
          </div>
        </div>
      )}
      {/* LEFT COLUMN */}
      {/* Dashboard Cards */}
      <div
        style={{
          flexBasis: '25%',
          // minWidth: '220px',
          minWidth: '150px',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          overflow: 'hidden',
          marginTop: '-20px'
        }}
      >
        <Card
          sx={{
            background: 'linear-gradient(145deg, #1E1E2F, #11111C)',
            color: '#E0E0E0',
            borderRadius: '14px',
            padding: '12px',
            boxShadow: '0 6px 18px rgba(0,0,0,0.4)',
            width: '270px',   // main card width
            minHeight: '250px', // main card height
            marginLeft: '-15px'
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              color: '#FFD700',
              fontWeight: 700,
              fontFamily: 'monospace',
              marginBottom: '12px',
              fontSize: 14,
              textTransform: 'uppercase'
            }}
          >
            Departments
          </Typography>

          {departmentListData.map((dept, i) => (
            <div
              key={dept.Id}
              onClick={() => handleCardClick && handleCardClick(dept)}
              className="dashboard-card"
              style={{
                background: '#2A2A3D',
                color: 'whitesmoke',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                padding: '12px 15px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer',
                minHeight: '35px',
                width: '100%',
                gap: '15px',
                marginBottom: '10px', // <-- space between cards
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              }}
            >
              <h5 style={{ fontSize: '12px', margin: 0 }}>{dept.Name}</h5>
            </div>
          ))}

        </Card>
      </div>

      {/* Department modal */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "20px",
            backgroundColor: "#0A1931",
            color: "#FFC300",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "#FFC300",
            textTransform: 'uppercase',
            fontSize: '14px'
          }}
        >
          Designation And Employee Data

          <div className="flex gap-2">
            <Button
              onClick={() => setModalOpen(false)}
              sx={{
                backgroundColor: "#a3e25cff",
                color: "#0A1931",
                textTransform: "none",
                borderRadius: "20px",
                fontSize: "12px",
                padding: "4px 18px",
                "&:hover": { backgroundColor: "#c1df1aff" },
              }}
            >
              ← Back
            </Button>
          </div>
        </DialogTitle>

        <DialogContent>
          {/* Table Content (same as before) */}
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 350,
              overflow: "auto",
              backgroundColor: "#10294e",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {["Sl.No", "Code", "Name"].map(
                    (col, idx) => (
                      <TableCell
                        key={idx}
                        sx={{
                          background: "#0A1931",
                          color: "#FFC300",
                          fontWeight: 700,
                          fontSize: 12,
                          textTransform: "uppercase",
                          padding: "2px 4px",
                          borderBottom: "2px solid #FFC300",
                        }}
                      >
                        {col}
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {Object.entries(groupedData1).map(([department, designations]) => (
                  <React.Fragment key={department}>
                    {/* Department Row */}
                    <TableRow
                      sx={{ backgroundColor: "#1b2a41", cursor: "pointer" }}
                      onClick={() => toggleDepartment1(department)}
                    >
                      <TableCell colSpan={5} sx={{ fontWeight: 700, fontSize: 13, color: "#0ebe8aff" }}>
                        {department} {expandedDepartDes[department] ? "▲" : "▼"}
                      </TableCell>
                    </TableRow>

                    {/* Designations */}
                    {expandedDepartDes[department] &&
                      Object.entries(designations).map(([designation, items]) => (
                        <React.Fragment key={designation}>
                          <TableRow
                            sx={{ backgroundColor: "#10294e", cursor: "pointer" }}
                            onClick={() => toggleDesignation1(department, designation)}
                          >
                            <TableCell
                              colSpan={5}
                              sx={{ fontWeight: 600, fontSize: 11, paddingLeft: 2, color: "#FFC300", padding: '10px' }}
                            >
                              {designation} {expandedDesignations1[`${department}-${designation}`] ? "▲" : "▼"}
                            </TableCell>
                          </TableRow>

                          {/* Items */}
                          {expandedDesignations1[`${department}-${designation}`] &&
                            items.map((item, index) => (
                              <TableRow
                                key={item.Id}
                                sx={{
                                  "&:hover": { backgroundColor: "#223a67", cursor: "pointer" },
                                }}
                              >
                                <TableCell sx={{ fontSize: 12, color: "#fff", padding: '10px' }}>{globalSerial++}</TableCell>
                                <TableCell sx={{ fontSize: 12, color: "#fff", padding: '10px' }}>{item.EmployeeCode}</TableCell>
                                <TableCell sx={{ fontSize: 12, color: "#fff", padding: '10px' }}>{item.EmployeeName}</TableCell>
                              </TableRow>
                            ))}
                        </React.Fragment>
                      ))}
                  </React.Fragment>
                ))}
              </TableBody>

            </Table>
          </TableContainer>

          <div className="text-center text-gray-400 text-xs mt-3">
            <CopyrightIcon
              sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
            />
            <b style={{ color: "#FFC300" }}>EFFTABS SOLUTIONS LLP</b>
          </div>
        </DialogContent>
      </Dialog>

      {/* CENTER COLUMN */}
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '10px', marginTop: '-10px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: 'linear-gradient(145deg, #2B2F3A, #212437)',
            padding: '20px',
            borderRadius: '25px',
            width: '115%',
            maxWidth: '1000px',
            fontFamily: 'Inter, sans-serif',
            color: '#FFFFFF',
            transition: 'all 0.3s ease',
            marginLeft: '-70px',
            gap: '20px',
          }}
        >
          {/* Header */}
          <h6 style={{ textAlign: 'center', marginBottom: '20px' }}>Attendance Dashboard</h6>

          {/* Summary Cards */}
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
            {todayactivityCards.map((card, i) => (
              <div
                key={i}
                className="dashboard-card"
                style={{
                  // backgroundColor: '#ffffff',
                  ...cardStyle,
                  //background: 'linear-gradient(135deg, #326965ff, #161004ff)',
                  color: 'whitesmoke',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  padding: '12px 15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  height: '50px',
                  width: '70%'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                }}
              >
                <div>{card.icon}</div>
                <h5 style={{ fontSize: '14px', margin: 0 }}>{card.title}</h5>
              </div>
            ))}
          </div>

          {/* Charts Section */}
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <div style={chartStyle}> {/* Example chart placeholder */}
              Attendance Trend Chart
            </div>
            <div style={chartStyle}>
              Department-wise Attendance
            </div>
          </div>

          {/* Recent Logs */}


        </div>

        {/* Dark Theme Modal for Employee List */}
        <Dialog
          open={openEmployeeModal}
          onClose={() => setOpenEmployeeModal(false)}
          fullWidth
          maxWidth={false} // disables MUI maxWidth restrictions
          PaperProps={{
            sx: {
              backgroundColor: '#0B132B',
              color: '#ffffff',
              borderRadius: '10px',
              width: '70%', // now this will apply
              margin: 'auto', // center horizontally
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            Employee List ({employeeData.length})

            <div style={{ marginBottom: '10px' }}>
              <input
                type="text"
                placeholder="Search by name or code..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  borderRadius: '6px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  backgroundColor: '#1A1F3B',
                  color: '#fff',
                  fontSize: '13px',
                  outline: 'none',
                }}
              />
            </div>
            <IconButton onClick={handleCloseEmployeeModal} sx={{ color: '#ffffff' }}>
              <CloseIcon />
            </IconButton>

          </DialogTitle>
          <DialogContent dividers>
            {/* Loader overlay */}
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  zIndex: 10,
                }}
              >
                {/* Diamond Loader */}
                <div
                  style={{
                    position: 'relative',
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'rotate(45deg)',
                    overflow: 'hidden',
                    borderRadius: '6px',
                    boxShadow: '0 6px 18px rgba(255,255,255,0.2)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      inset: '6px',
                      margin: 'auto',
                      background: '#ffffff',
                      borderRadius: '4px',
                    }}
                  ></div>
                  <div
                    style={{
                      position: 'absolute',
                      inset: '-12px',
                      margin: 'auto',
                      background: '#52fad8ff',
                      borderRadius: '6px',
                      animation: 'diamondLoader 2s linear infinite',
                    }}
                  ></div>
                  <style>
                    {`
            @keyframes diamondLoader {
              0%,10% { transform: translate(-50px,-50px) rotate(-45deg); }
              90%,100% { transform: translate(0px,0px) rotate(-45deg); }
            }
          `}
                  </style>
                </div>
              </div>
            )}
            {!loading && (filteredEmployees.length === 0 ? (
              <p>No Data Found</p>
            ) : (

              <div style={{ width: '100%', maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', maxHeight: '400px', borderCollapse: 'collapse', color: '#fff' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1A1F3B' }}>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',
                          top: 0,
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Code
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Department
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Designation
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredEmployees.map((emp, index) => (
                      <tr
                        key={index}
                        style={{
                          borderBottom: '1px solid rgba(255,255,255,0.1)',
                          transition: 'background 0.2s',
                        }}
                      >
                        <td style={{ padding: '4px', fontSize: '12px' }}>{emp.EmployeeCode}</td>
                        <td style={{ padding: '4px', fontSize: '12px' }}>{emp.EmployeeName}</td>
                        <td style={{ padding: '4px', fontSize: '12px' }}>{emp.DepartmentName}</td>
                        <td style={{ padding: '4px', fontSize: '12px' }}>{emp.DesignationName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </DialogContent>

        </Dialog>

        {/* Punch In Modal */}
        <Dialog
          open={openPunchModal}
          onClose={handleClosePunchModal}
          fullWidth
          maxWidth={false} // disables MUI maxWidth restrictions
          PaperProps={{
            sx: {
              backgroundColor: '#0B132B',
              // background: 'linear-gradient(135deg, #326965ff, #161004ff)',
              color: '#B0EBB4',
              borderRadius: '10px',
              width: '70%', // now this will apply
              margin: 'auto', // center horizontally
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            Punch-In List ({punchinData.length})

            <div style={{ marginBottom: '10px' }}>
              <input
                type="text"
                placeholder="Search by name or code..."
                value={searchTerm1}
                onChange={(e) => setSearchTerm1(e.target.value)}
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  borderRadius: '6px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  backgroundColor: '#1A1F3B',
                  color: '#fff',
                  fontSize: '10px',
                  outline: 'none',
                }}
              />
            </div>
            <IconButton onClick={handleClosePunchModal} sx={{ color: '#ffffff' }}>
              <CloseIcon />
            </IconButton>

          </DialogTitle>
          <DialogContent dividers>
            {/* Loader overlay */}
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  zIndex: 10,
                }}
              >
                {/* Diamond Loader */}
                <div
                  style={{
                    position: 'relative',
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'rotate(45deg)',
                    overflow: 'hidden',
                    borderRadius: '6px',
                    boxShadow: '0 6px 18px rgba(255,255,255,0.2)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      inset: '6px',
                      margin: 'auto',
                      background: '#ffffff',
                      borderRadius: '4px',
                    }}
                  ></div>
                  <div
                    style={{
                      position: 'absolute',
                      inset: '-12px',
                      margin: 'auto',
                      background: '#52fad8ff',
                      borderRadius: '6px',
                      animation: 'diamondLoader 2s linear infinite',
                    }}
                  ></div>
                  <style>
                    {`
            @keyframes diamondLoader {
              0%,10% { transform: translate(-50px,-50px) rotate(-45deg); }
              90%,100% { transform: translate(0px,0px) rotate(-45deg); }
            }
          `}
                  </style>
                </div>
              </div>
            )}

            {/* Table or No Data message */}
            {!loading && (filteredPunchins.length === 0 ? (
              <p>No PunchIn List Found</p>
            ) : (
              <div style={{ width: '100%', maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', maxHeight: '400px', borderCollapse: 'collapse', color: '#B0EBB4' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1A1F3B' }}>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Branch
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',
                          top: 0,
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Code
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Department
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Designation
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Date
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Punch-In
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPunchins.map((punchin, index) => {
                      // Check if this punchin belongs to the same branch as the previous one
                      const showBranchName =
                        index === 0 || punchin.BranchName !== filteredPunchins[index - 1].BranchName;
                      const showEmpCode =
                        index === 0 || punchin.EmployeeCode !== filteredPunchins[index - 1].EmployeeCode;
                      const showEmpName =
                        index === 0 || punchin.EmployeeName !== filteredPunchins[index - 1].EmployeeName;
                      const showDepartment =
                        index === 0 || punchin.Department !== filteredPunchins[index - 1].Department;
                      const showDesignation =
                        index === 0 || punchin.Designation !== filteredPunchins[index - 1].Designation;
                      // Set row background color based on employee change
                      const rowBackground = showEmpCode ? '#e8f4ff' : 'transparent'; // new employee row gets light blue
                      const rowcolor = showEmpCode ? 'black' : '#B0EBB4'; // new employee row gets light blue

                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: '1px solid rgba(255,255,255,0.1)',
                            transition: 'background 0.2s',
                            backgroundColor: rowBackground,
                            color: rowcolor
                          }}
                        >
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showBranchName ? punchin.BranchName : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showEmpCode ? punchin.EmployeeCode : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showEmpName ? punchin.EmployeeName : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showDepartment ? punchin.Department : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showDesignation ? punchin.Designation : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>{formatDate(punchin.AttendanceDate)}</td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {formatTimeSpan(punchin.InTime)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                </table>
              </div>
            ))}
          </DialogContent>
        </Dialog>

        {/* Punch Out Modal */}
        <Dialog
          open={openPunchOutModal}
          onClose={handleClosePunchOutModal}
          fullWidth
          maxWidth={false} // disables MUI maxWidth restrictions
          PaperProps={{
            sx: {
              backgroundColor: '#0B132B',
              // background: 'linear-gradient(135deg, #887e48ff, #161004ff)',
              color: '#DBE9B7',
              borderRadius: '10px',
              width: '70%', // now this will apply
              margin: 'auto', // center horizontally
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            Punch-Out List ({punchoutData.length})

            <div style={{ marginBottom: '10px' }}>
              <input
                type="text"
                placeholder="Search by name or code..."
                value={searchTerm1}
                onChange={(e) => setSearchTerm1(e.target.value)}
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  borderRadius: '6px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  backgroundColor: '#1A1F3B',
                  color: '#fff',
                  fontSize: '13px',
                  outline: 'none',
                }}
              />
            </div>
            <IconButton onClick={handleClosePunchOutModal} sx={{ color: '#ffffff' }}>
              <CloseIcon />
            </IconButton>

          </DialogTitle>
          <DialogContent dividers>
            {/* {loading ? (
              <p>Loading...</p>
            ) : filteredPunchouts.length === 0 ? (
              <p>No PunchIn List Found</p>
            ) : ( */}
            {/* Loader overlay */}
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  zIndex: 10,
                }}
              >
                {/* Diamond Loader */}
                <div
                  style={{
                    position: 'relative',
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'rotate(45deg)',
                    overflow: 'hidden',
                    borderRadius: '6px',
                    boxShadow: '0 6px 18px rgba(255,255,255,0.2)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      inset: '6px',
                      margin: 'auto',
                      background: '#ffffff',
                      borderRadius: '4px',
                    }}
                  ></div>
                  <div
                    style={{
                      position: 'absolute',
                      inset: '-12px',
                      margin: 'auto',
                      background: '#52fad8ff',
                      borderRadius: '6px',
                      animation: 'diamondLoader 2s linear infinite',
                    }}
                  ></div>
                  <style>
                    {`
            @keyframes diamondLoader {
              0%,10% { transform: translate(-50px,-50px) rotate(-45deg); }
              90%,100% { transform: translate(0px,0px) rotate(-45deg); }
            }
          `}
                  </style>
                </div>
              </div>
            )}
            {!loading && (filteredPunchouts.length === 0 ? (
              <p>No Punch Out Found</p>
            ) : (
              <div style={{ width: '100%', maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', maxHeight: '400px', borderCollapse: 'collapse', color: '#DBE9B7' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1A1F3B' }}>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Branch
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',
                          top: 0,
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Code
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Department
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Designation
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Date
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Punch-In
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Punch-Out
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPunchouts.map((punchout, index) => {
                      // Check if this punchin belongs to the same branch as the previous one
                      // const showBranchName =
                      //   index === 0 || punchout.BranchName !== filteredPunchouts[index - 1].BranchName;
                      const showBranchName =
                        index === 0 || punchout.BranchName !== filteredPunchouts[index - 1].BranchName;
                      const showEmpCode =
                        index === 0 || punchout.EmployeeCode !== filteredPunchouts[index - 1].EmployeeCode;
                      const showEmpName =
                        index === 0 || punchout.EmployeeName !== filteredPunchouts[index - 1].EmployeeName;
                      const showDepartment =
                        index === 0 || punchout.Department !== filteredPunchouts[index - 1].Department;
                      const showDesignation =
                        index === 0 || punchout.Designation !== filteredPunchouts[index - 1].Designation;
                      // Set row background color based on employee change
                      const rowBackground = showEmpCode ? '#e8f4ff' : 'transparent'; // new employee row gets light blue
                      const rowcolor = showEmpCode ? 'black' : '#DBE9B7'; // new employee row gets light blue

                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: '1px solid rgba(255,255,255,0.1)',
                            transition: 'background 0.2s',
                            backgroundColor: rowBackground,
                            color: rowcolor
                          }}
                        >
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showBranchName ? punchout.BranchName : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showEmpCode ? punchout.EmployeeCode : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showEmpName ? punchout.EmployeeName : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showDepartment ? punchout.Department : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {showDesignation ? punchout.Designation : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>{formatDate(punchout.AttendanceDate)}</td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {formatTimeSpan(punchout.InTime)}
                          </td>
                          <td style={{ padding: '4px', fontSize: '12px' }}>
                            {formatTimeSpan(punchout.OutTime)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                </table>
              </div>
            ))}
          </DialogContent>
        </Dialog>

        {/* Not Yet Started Modal */}
        <Dialog
          open={openNotstartedModal}
          onClose={handleCloseNotStartedModal}
          fullWidth
          maxWidth={false} // disables MUI maxWidth restrictions
          PaperProps={{
            sx: {
              backgroundColor: '#0B132B',
              // background: 'linear-gradient(135deg, #326965ff, #161004ff)',
              color: '#f1f1f1ff',
              borderRadius: '10px',
              width: '70%', // now this will apply
              margin: 'auto', // center horizontally
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              textTransform: 'uppercase',
              fontSize: '14px'
            }}
          >
            {/* Not Yet Started ({notStartedData.length}) */}
            Not Yet Started ({notStartedData.length})
            {displayMonthYear && ` - ${displayMonthYear}`}

            <div style={{ marginBottom: '10px' }}>
              <input
                type="text"
                placeholder="Search by name or code..."
                value={searchTerm3}
                onChange={(e) => setSearchTerm3(e.target.value)}
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  borderRadius: '6px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  backgroundColor: '#1A1F3B',
                  color: '#fff',
                  fontSize: '10px',
                  outline: 'none',
                }}
              />
            </div>
            <IconButton onClick={handleCloseNotStartedModal} sx={{ color: '#ffffff' }}>
              <CloseIcon />
            </IconButton>

          </DialogTitle>
          <DialogContent dividers>
            {/* {loading ? (
              <p>Loading...</p>
            ) : filteredNotStarted.length === 0 ? (
              <p>No Data Found</p>
            ) : ( */}
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  zIndex: 10,
                }}
              >
                {/* Diamond Loader */}
                <div
                  style={{
                    position: 'relative',
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'rotate(45deg)',
                    overflow: 'hidden',
                    borderRadius: '6px',
                    boxShadow: '0 6px 18px rgba(255,255,255,0.2)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      inset: '6px',
                      margin: 'auto',
                      background: '#ffffff',
                      borderRadius: '4px',
                    }}
                  ></div>
                  <div
                    style={{
                      position: 'absolute',
                      inset: '-12px',
                      margin: 'auto',
                      background: '#52fad8ff',
                      borderRadius: '6px',
                      animation: 'diamondLoader 2s linear infinite',
                    }}
                  ></div>
                  <style>
                    {`
            @keyframes diamondLoader {
              0%,10% { transform: translate(-50px,-50px) rotate(-45deg); }
              90%,100% { transform: translate(0px,0px) rotate(-45deg); }
            }
          `}
                  </style>
                </div>
              </div>
            )}
            {!loading && (filteredNotStarted.length === 0 ? (
              <p>No Data Found</p>
            ) : (
              <div style={{ width: '100%', maxHeight: '400px', overflowY: 'auto', marginTop: '-20px' }}>
                <table style={{ width: '100%', maxHeight: '400px', borderCollapse: 'collapse', color: 'lightred' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1A1F3B' }}>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Branch
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',
                          top: 0,
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Code
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Department
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Designation
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',
                          top: 0,
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Date
                      </th>
                      <th
                        style={{
                          textAlign: 'left',
                          padding: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          position: 'sticky',     // 👈 makes it stick
                          top: 0,                 // 👈 stick to top
                          backgroundColor: '#1A1F3B',
                          zIndex: 1,
                        }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredNotStarted.map((notstarted, index) => {
                      // Check if this punchin belongs to the same branch as the previous one
                      const showBranchName =
                        index === 0 || notstarted.BranchName !== filteredNotStarted[index - 1].BranchName;
                      const showEmpCode =
                        index === 0 || notstarted.EmployeeCode !== filteredNotStarted[index - 1].EmployeeCode;
                      const showEmpName =
                        index === 0 || notstarted.EmployeeName !== filteredNotStarted[index - 1].EmployeeName;
                      const showDepartment =
                        index === 0 || notstarted.Department !== filteredNotStarted[index - 1].Department;
                      const showDesignation =
                        index === 0 || notstarted.Designation !== filteredNotStarted[index - 1].Designation;
                      // Set row background color based on employee change
                      const rowBackground = showEmpCode ? '#e8f4ff' : 'transparent'; // new employee row gets light blue
                      const rowcolor = showEmpCode ? 'black' : 'white'; // new employee row gets light blue

                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: '1px solid rgba(255,255,255,0.1)',
                            transition: 'background 0.2s',
                            backgroundColor: rowBackground,
                            color: rowcolor
                          }}
                        >
                          <td style={{ padding: '4px', fontSize: '11px' }}>
                            {showBranchName ? notstarted.BranchName : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>
                            {showEmpCode ? notstarted.EmployeeCode : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>
                            {showEmpName ? notstarted.EmployeeName : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>
                            {showDepartment ? notstarted.Department : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>
                            {showDesignation ? notstarted.Designation : '-'}
                          </td>
                          <td style={{ padding: '4px', fontSize: '11px' }}>{formatDate(notstarted.AttendanceDate)}</td>
                          {/* Status with color coding */}
                          <td
                            style={{
                              padding: '4px',
                              fontSize: '10px',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              backgroundColor:
                                notstarted.statusName === 'P'
                                  ? '#4CAF50'
                                  : notstarted.statusName === 'A'
                                    ? '#F44336'
                                    : notstarted.statusName === 'HLF'
                                      ? '#FFEB3B'
                                      : notstarted.statusName === 'MIS'
                                        ? '#F8BBD0'
                                        : 'transparent',
                              color:
                                notstarted.statusName === 'HLF' ? '#000' : '#fff', // better contrast for yellow
                              borderRadius: '4px',
                            }}
                          >
                            {notstarted.statusName}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                </table>
              </div>
            ))}
          </DialogContent>
        </Dialog>
      </div>

      {/* RIGHT COLUMN */}
      <div style={{ flexBasis: '25%', minWidth: '220px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px', overflow: 'hidden' }}>

        <Card
          sx={{
            background: '#1E1E2F',
            //background: 'linear-gradient(135deg, #326965ff, #161004ff)',
            color: '#fff',
            p: 2,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            mt: -2,
          }}
        >
          {/* Top Section - Employee Filter */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', minWidth: '220px' }}>
                <Select
                  value={selectedEmployeeType}
                  onChange={setSelectedEmployeeType}
                  options={employeedropOptions}
                  placeholder="Employee Name"
                  isSearchable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '25px',
                      minWidth: '220px',
                      fontSize: '11px',
                      color: 'black',
                      padding: '0 4px',
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 1301,
                      fontSize: '11px',
                      color: 'black',
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: '25px',
                      minHeight: '25px',
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: '0 4px',
                    }),
                  }}
                />
              </div>

              <Button
                style={{
                  borderRadius: '20px',
                  fontWeight: '600',
                  fontSize: '12px',
                  color: '#e7e9f0',
                  textTransform: 'uppercase',
                  padding: '5px 12px',
                  cursor: 'pointer',
                }}
                onClick={fetchEmployeAttendancetableData}
              >
                <PreviewIcon style={{ fontSize: '19px' }} />
              </Button>
            </div>
          </div>

          {/* Month Navigation */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
              width: '100%',
            }}
          >
            <ArrowBackIosIcon
              onClick={prevMonth}
              sx={{
                cursor: 'pointer',
                color: '#FFD700',
                fontSize: '20px',
                transition: '0.2s',
                '&:hover': { transform: 'scale(1.2)' },
              }}
            />
            <Typography fontWeight={700} sx={{ flex: 1, textAlign: 'center', fontSize: '18px', color: '#FFF' }}>
              {monthLabel}
            </Typography>
            <ArrowForwardIosIcon
              onClick={nextMonth}
              sx={{
                cursor: 'pointer',
                color: '#FFD700',
                fontSize: '20px',
                transition: '0.2s',
                '&:hover': { transform: 'scale(1.2)' },
              }}
            />
          </div>

          {/* Legend */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: '10px',
              flexWrap: 'wrap',
            }}
          >
            {Object.entries(attendanceColors).map(([status, color]) => (
              <div key={status} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <div
                  style={{
                    width: '12px',
                    height: '12px',
                    background: color,
                    borderRadius: '4px',
                    border: '1px solid #000',
                  }}
                ></div>
                <span style={{ fontSize: '12px', color: 'whitesmoke' }}>
                  ({status})
                </span>
              </div>
            ))}
          </div>

          {/* Days Header */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: '5px',
              marginBottom: '8px',
              width: '100%',
              maxWidth: '320px',
            }}
          >
            {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d) => (
              <div key={d} style={{ textAlign: 'center', fontWeight: 600, fontSize: '12px', color: 'whitesmoke' }}>
                {d}
              </div>
            ))}
          </div>

          {/* Calendar Grid */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: '6px',
              justifyContent: 'center',
              width: '100%',
              maxWidth: '320px',
            }}
          >
            {calendar1.weeks.flat().map((cell, idx) => {
              if (!cell.day) return <div key={idx}></div>;

              const today = new Date();
              const isToday =
                cell.day === today.getDate() &&
                calendar1.month === today.getMonth() &&
                calendar1.year === today.getFullYear();

              const key = `${calendar1.year}-${calendar1.month}-${cell.day}`;
              const status = attendanceMap[key];

              const backgroundColor = isToday
                ? 'linear-gradient(135deg, #FFD700, #FFA500)'
                : status
                  ? attendanceColors[status]
                  : '#2e3036ff';

              const textColor = isToday || status ? '#1A1F2B' : '#f7faf7ff';

              return (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '32px',
                    borderRadius: '10px',
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: 'pointer',
                    background: backgroundColor,
                    color: textColor,
                    boxShadow: '0 4px 10px rgba(0,0,0,0.4)',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.4)';
                  }}
                  //  onClick={() => setSelectedDate1(new Date(calendar1.year, calendar1.month, cell.day))}
                  onClick={() => handleSelectedDayModalOpen(new Date(calendar1.year, calendar1.month, cell.day))}
                >
                  {cell.day}
                </div>
              );
            })}
          </div>
        </Card>

        <Dialog
          open={openselectedDaymodal}
          onClose={() => setSelectedDayModal(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: '20px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{ textAlign: 'center', fontWeight: 700, letterSpacing: 1, backgroundColor: '#0A1931', color: '#FFC300' }}
          >
            {`Summary - ${formatDate(selectedDate1)}`}
          </DialogTitle>

          <DialogContent sx={{ backgroundColor: '#0A1931', color: '#fff' }}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>Punch In: {daySummary.PunchInCount}</Grid>
              {/* <Grid item xs={12}>Punch Out: {daySummary.PunchOutCount}</Grid> */}
              <Grid item xs={12}>Not Punched Yet: {daySummary.NotPunchedYetCount}</Grid>
              <Grid item xs={12}>Total Employees: {daySummary.TotalEmployees}</Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Notifications */}
        {/* <Typography variant="subtitle2" fontWeight={600}>Notifications</Typography>
         <div style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '12px' }}>
          <NotificationsActiveIcon color="warning" fontSize="small" />
          <span>3 employees pending salary approval</span>
        </div> */}

        <Typography variant="subtitle2" fontWeight={600}>Quick Actions</Typography>
        <Button
          startIcon={<SettingsIcon />}
          onClick={handleOpen}
          variant="contained"
          sx={{ mb: 1, fontSize: '12px', padding: '4px 8px' }}
        >
          Settings
        </Button>
        <Button
          startIcon={<HelpOutlineIcon />}
          onClick={handlehelpOpen}
          variant="contained"
          sx={{ fontSize: '12px', padding: '4px 8px' }}
        >
          Help Center
        </Button>

        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth
          PaperProps={{
            sx: {
              borderRadius: '20px',
              overflow: 'hidden',
            },
          }}
        >
          <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, letterSpacing: 1, backgroundColor: '#0A1931', color: '#FFC300' }}>
            ⚙ Settings
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: '#0A1931' }}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={6}>
                <Card elevation={6} sx={{ borderRadius: 3, backgroundColor: '#10294e', transition: 'transform 0.2s, box-shadow 0.3s', '&:hover': { transform: 'scale(1.05)', boxShadow: '0px 4px 20px rgba(255, 195, 0, 0.4)' } }}>
                  <CardActionArea onClick={onBatchSettings} sx={{ p: 1 }}>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <StorageIcon fontSize="large" sx={{ color: '#FFC300' }} />
                      <Typography variant="subtitle2" fontWeight={600} sx={{ color: '#FFC300', fontFamily: 'monospace', textTransform: 'uppercase', textAlign: 'center' }}>
                        Bata Settings
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card elevation={6} sx={{ borderRadius: 3, backgroundColor: '#10294e', transition: 'transform 0.2s, box-shadow 0.3s', '&:hover': { transform: 'scale(1.05)', boxShadow: '0px 4px 20px rgba(255, 195, 0, 0.4)' } }}>
                  <CardActionArea onClick={handleOpenShiftModal} sx={{ p: 1 }}>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                      <SwapHorizIcon fontSize="large" sx={{ color: '#FFC300' }} />
                      <Typography variant="subtitle2" fontWeight={600} sx={{ color: '#FFC300', fontFamily: 'monospace', textTransform: 'uppercase', textAlign: 'center' }}>
                        Shift Changes
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Bata Settings Modal */}
        <Dialog
          open={openBataModal}
          onClose={() => setOpenBataModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "20px",
              backgroundColor: "#0A1931",
              color: "#FFC300",
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#FFC300",
            }}
          >
            Bata Setting

            <div className="flex gap-2">
              <Tooltip title="Create Bata Setting" arrow>
                <Button
                  onClick={handleOpenCreateModal}
                  variant="contained"
                  sx={{
                    backgroundColor: "#FFC300",
                    color: "#0A1931",
                    textTransform: "none",
                    borderRadius: "20px",
                    fontSize: "12px",
                    padding: "4px 18px",
                    "&:hover": { backgroundColor: "#ffdb4d" },
                  }}
                >
                  + Create
                </Button>
              </Tooltip>

              <Button
                onClick={() => setOpenBataModal(false)}
                sx={{
                  backgroundColor: "#a3e25cff",
                  color: "#0A1931",
                  textTransform: "none",
                  borderRadius: "20px",
                  fontSize: "12px",
                  padding: "4px 18px",
                  "&:hover": { backgroundColor: "#c1df1aff" },
                }}
              >
                ← Back
              </Button>
            </div>
          </DialogTitle>

          <DialogContent>
            {/* Table Content (same as before) */}
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: 350,
                overflow: "auto",
                backgroundColor: "#10294e",
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {["Sl.No", "Shift", "Bata Amount", "Punch-In", "Punch-Out"].map(
                      (col, idx) => (
                        <TableCell
                          key={idx}
                          sx={{
                            background: "#0A1931",
                            color: "#FFC300",
                            fontWeight: 700,
                            fontSize: 13,
                            textTransform: "uppercase",
                            padding: "6px 8px",
                            borderBottom: "2px solid #FFC300",
                          }}
                        >
                          {col}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Object.entries(groupedData).map(([department, designations]) => (
                    <React.Fragment key={department}>
                      {/* Department Row */}
                      <TableRow
                        sx={{ backgroundColor: "#1b2a41", cursor: "pointer" }}
                        onClick={() => toggleDepartment(department)}
                      >
                        <TableCell colSpan={5} sx={{ fontWeight: 700, fontSize: 13, color: "#0ebe8aff" }}>
                          {department} {expandedDepartments[department] ? "▲" : "▼"}
                        </TableCell>
                      </TableRow>

                      {/* Designations */}
                      {expandedDepartments[department] &&
                        Object.entries(designations).map(([designation, items]) => (
                          <React.Fragment key={designation}>
                            <TableRow
                              sx={{ backgroundColor: "#10294e", cursor: "pointer" }}
                              onClick={() => toggleDesignation(department, designation)}
                            >
                              <TableCell
                                colSpan={5}
                                sx={{ fontWeight: 600, fontSize: 11, paddingLeft: 2, color: "#FFC300" }}
                              >
                                {designation} {expandedDesignations[`${department}-${designation}`] ? "▲" : "▼"}
                              </TableCell>
                            </TableRow>

                            {/* Items */}
                            {expandedDesignations[`${department}-${designation}`] &&
                              items.map((item, index) => (
                                <TableRow
                                  key={item.Id}
                                  sx={{
                                    "&:hover": { backgroundColor: "#223a67", cursor: "pointer" },
                                  }}
                                >
                                  <TableCell sx={{ fontSize: 12, color: "#fff" }}>{globalSerial++}</TableCell>
                                  <TableCell sx={{ fontSize: 12, color: "#fff" }}>{item.WorkShiftName}</TableCell>
                                  <TableCell sx={{ fontSize: 12, color: "#fff" }}>{item.BataAmount}</TableCell>
                                  <TableCell sx={{ fontSize: 12, color: "#fff" }}>{formatTimeSpan(item.PunchInTime)}</TableCell>
                                  <TableCell sx={{ fontSize: 12, color: "#fff" }}>{formatTimeSpan(item.PunchOutTime)}</TableCell>
                                </TableRow>
                              ))}
                          </React.Fragment>
                        ))}
                    </React.Fragment>
                  ))}
                </TableBody>

              </Table>
            </TableContainer>

            <div className="text-center text-gray-400 text-xs mt-3">
              <CopyrightIcon
                sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
              />
              <b style={{ color: "#FFC300" }}>EFFTABS SOLUTIONS LLP</b>
            </div>
          </DialogContent>
        </Dialog>

        {/* ==================== Nested Create Modal ==================== */}
        <Modal open={openCreateModal} onClose={handleCloseBataModal}>
          <Box sx={modalStyle}>
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", color: "#FFD700" }}
              >
                Create Bata
              </Typography>

              <div className="flex gap-2">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isLoading}
                  sx={{
                    borderRadius: "8px",
                    height: "26px",
                    backgroundColor: "#FFD700",
                    color: "#0B132B",
                    "&:hover": { backgroundColor: "#E6C200" },
                  }}
                  onClick={submitData}
                >
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "💾 Save"
                  )}
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => setOpenCreateModal(false)}
                  sx={{
                    borderRadius: "8px",
                    height: "26px",
                    color: "#FFD700",
                    borderColor: "#FFD700",
                    "&:hover": { backgroundColor: "#1C2541" },
                  }}
                >
                  ← Back
                </Button>
              </div>
            </div>

            {/* Body */}
            <Card
              sx={{
                mt: 1,
                p: 2,
                borderRadius: 2,
                boxShadow: 3,
                border: "1px solid #FFD700",
                background: "#1C2541",
              }}
            >
              {/* Section 1 - Basic Info */}
              <div className="mb-4 overflow-x-auto" style={{ marginTop: '10px' }}>
                <div className="w-full flex gap-2">
                  {/* Department */}
                  <div className="w-2/6">
                    <label
                      className="block tracking-wide text-xs mb-1"
                      style={{ color: "#FFD700" }}
                    >
                      Department
                    </label>
                    <select
                      className="border rounded w-full focus:shadow-outline"
                      value={selectedDepartment}
                      style={{
                        height: "26px",
                        fontSize: "12px",
                        padding: "0 6px",
                        lineHeight: "1.2",
                        backgroundColor: "#0B132B",
                        color: "#FFD700",
                        border: "1px solid #FFD700",
                      }}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        const selectedDept = dropdownDepartmentOptions.find(
                          (dept) => dept.Id.toString() === selectedValue
                        );

                        setSelectedDepartment(selectedValue);
                        setFormData((prev) => ({
                          ...prev,
                          DepartmentId: selectedValue,
                          DepartmentName: selectedDept ? selectedDept.Name : "",
                        }));

                        if (selectedValue) {
                          fetchSlabDetails(selectedValue, selectedDesignation);
                        }
                      }}
                    >
                      <option value="">Select Department</option>
                      {dropdownDepartmentOptions.map((category) => (
                        <option key={category.Id} value={category.Id} style={{ color: "white" }}>
                          {category.Name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Designation */}
                  <div className="w-4/6">
                    <label
                      className="block tracking-wide text-xs mb-1"
                      style={{ color: "#FFD700" }}
                    >
                      Designation
                    </label>
                    <select
                      className="border rounded w-full focus:shadow-outline"
                      value={selectedDesignation}
                      style={{
                        height: "26px",
                        fontSize: "12px",
                        padding: "0 6px",
                        lineHeight: "1.2",
                        backgroundColor: "#0B132B",
                        color: "#FFD700",
                        border: "1px solid #FFD700",
                      }}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        const selectedDesig = dropdownDesignationOptions.find(
                          (dept) => dept.Id.toString() === selectedValue
                        );

                        setSelectedDesignation(selectedValue);
                        setFormData((prev) => ({
                          ...prev,
                          DesignationId: selectedValue,
                          DesignationName: selectedDesig ? selectedDesig.Name : "",
                        }));

                        if (selectedValue) {
                          fetchSlabDetails(selectedDepartment, selectedValue);
                        }
                      }}
                    >
                      <option value="">Select Designation</option>
                      {dropdownDesignationOptions.map((category) => (
                        <option key={category.Id} value={category.Id} style={{ color: "white" }}>
                          {category.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {/* Data Table */}
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  marginBottom: "13px",
                  border: "1px solid #FFD700",
                  borderRadius: "4px",
                  backgroundColor: "#0B132B",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "13px",
                    fontFamily: "monospace",
                  }}
                >
                  <thead style={{ backgroundColor: "#FFD700", color: "#0B132B" }}>
                    <tr>
                      {["SL.No", "Shift", "Bata"].map((header, idx) => (
                        <th
                          key={idx}
                          style={{
                            padding: "4px",
                            textAlign: idx > 1 ? "center" : "left",
                            borderBottom: "1px solid #FFD700",
                            textTransform: "uppercase",
                            fontSize: "10px",
                          }}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#1C2541" : "#0B132B",
                          borderBottom: "1px solid #FFD700",
                          color: "#FFD700",
                        }}
                      >
                        <td style={{ padding: "4px 6px", textAlign: "left" }}>
                          {index + 1}
                        </td>
                        <td
                          style={{
                            fontSize: "13px",
                            padding: "4px",
                            minWidth: "200px",
                          }}
                        >
                          {item.WorkShiftName}
                        </td>
                        <td
                          style={{
                            padding: "2px",
                            textAlign: "right",
                            width: "120px",
                          }}
                        >
                          <input
                            type="number"
                            value={item.BataAmount}
                            name="BataAmount"
                            onChange={(e) =>
                              handleCalculation(e, index, "BataAmount")
                            }
                            style={{
                              width: "100%",
                              textAlign: "right",
                              fontWeight: "bold",
                              border: "1px solid #FFD700",
                              borderRadius: "3px",
                              padding: "2px",
                              background: "#1C2541",
                              color: "#FFD700",
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Footer */}
              <div
                className="text-center text-sm mt-6 border-t pt-2"
                style={{ color: "#FFD700", borderColor: "#FFD700" }}
              >
                <CopyrightIcon
                  fontSize="small"
                  className="inline-block mr-1"
                  sx={{ color: "#FFD700" }}
                />
                <b className="font-serif">EFFTABS SOLUTIONS LLP</b>
              </div>
            </Card>
          </Box>
        </Modal>

        {/* Shift Modal */}
        <Modal open={shiftModalOpen} onClose={handleCloseShiftModal}>
          <Box
            sx={{
              ...modalStyleShift,
              bgcolor: "#0B132B", // Dark blue background
              color: "#DFFFD6", // Light green default text
            }}
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#DFFFD6" }}>
                Shift
              </Typography>
              <Tooltip title="Back" arrow>
                <Button
                  onClick={handleCloseShiftModal}
                  sx={{
                    borderRadius: "8px",
                    height: "26px",
                    color: "#DFFFD6",
                    borderColor: "#DFFFD6",
                    border: "1px solid",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#1A2A4A" },
                  }}
                >
                  ← Back
                </Button>
              </Tooltip>
            </div>

            {/* Table */}
            <div className="rounded-lg border border-green-200 mt-2">
              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "none",
                  maxHeight: 400,
                  borderRadius: "8px",
                  bgcolor: "#0B132B",
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {["Sl.No", "Name", "Punch In", "Punch Out", ""].map((col, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            color: "#DFFFD6",
                            fontSize: "12px",
                            fontWeight: 600,
                            textAlign: col === "" ? "right" : "left",
                            backgroundColor: "#0D1B2A",
                            padding: "4px",
                          }}
                        >
                          {col}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {shiftData.map((item, index) => (
                      <TableRow
                        key={item.Id}
                        sx={{
                          "&:hover": { backgroundColor: "#1A2A4A" },
                          transition: "0.2s ease-in-out",
                        }}
                      >
                        <TableCell sx={{ fontSize: 12, color: "#DFFFD6", fontWeight: "bold" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: "#DFFFD6" }}>{item.Name}</TableCell>
                        <TableCell sx={{ fontSize: 12, color: "#DFFFD6" }}>
                          {formatTimeSpan(item.PunchInTime)}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: "#DFFFD6" }}>
                          {formatTimeSpan(item.PunchOutTime)}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: "#DFFFD6" }}>
                          <Tooltip title="Edit Shift" arrow>
                            <IconButton onClick={() => openDetailModal(item.Id)}>
                              <EditIcon style={{ color: "white", fontSize: "17px" }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <div className="text-center text-xs mt-3" style={{ color: "#DFFFD6" }}>
              <CopyrightIcon sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }} />
              <b style={{ fontFamily: "Georgia, serif" }}>EFFTABS SOLUTIONS LLP</b>
            </div>
          </Box>
        </Modal>

        {/* Detail/Edit Modal */}
        <Modal open={isDetailModalOpen} onClose={toggleModalBranch}>
          <div className="fixed inset-0 flex items-center justify-center z-50 animate-zoomIn">
            <div
              className="rounded-lg shadow-xl overflow-hidden"
              style={{
                width: "400px",
                backgroundColor: "#1f2937", // dark gray
                color: "#f9fafb", // light text
                fontFamily: 'Cambria, "Times New Roman", serif',
              }}
            >
              {/* Header */}
              <div
                className="text-center py-2 font-bold"
                style={{
                  backgroundColor: "#111827", // darker header
                  fontSize: "16px",
                  letterSpacing: "0.5px",
                }}
              >
                Shift Edit
              </div>

              {/* Body */}
              <div className="p-4 space-y-4">
                {/* Name Field */}
                <div>
                  <label className="block text-xs font-semibold mb-1">Name</label>
                  <input
                    type="text"
                    name="Name"
                    placeholder="Enter Name"
                    value={updatedData.Name || ""}
                    onChange={handleUpdateInputChange}
                    className="w-full px-3 py-2 text-sm rounded bg-gray-800 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
                  />
                </div>

                {/* Time Fields */}
                <div className="grid grid-cols-2 gap-3" style={{ marginTop: '10px' }}>
                  <div>
                    <label className="block text-xs font-semibold mb-1">Punch In</label>
                    <input
                      type="time"
                      name="PunchInTime"
                      value={updatedData.PunchInTime || ""}
                      onChange={handleUpdateInputChange}
                      className="w-full px-3 py-2 text-sm rounded bg-gray-800 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold mb-1">Punch Out</label>
                    <input
                      type="time"
                      name="PunchOutTime"
                      value={updatedData.PunchOutTime || ""}
                      onChange={handleUpdateInputChange}
                      className="w-full px-3 py-2 text-sm rounded bg-gray-800 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex justify-end gap-3" style={{ marginTop: '10px' }}>
                  <button
                    onClick={updateRecord}
                    className="px-4 py-2 text-sm font-bold rounded bg-blue-600 hover:bg-blue-700 transition"
                  >
                    Update
                  </button>
                  <button
                    onClick={toggleModalBranch}
                    className="px-4 py-2 text-sm font-bold rounded bg-gray-700 hover:bg-red-600 text-white transition"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* Help Modal */}
        <Modal
          open={helpOpen}
          onClose={handlehelpClose}
          aria-labelledby="help-modal-title"
          aria-describedby="help-modal-description"
        >
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: 300, sm: 400 },
              bgcolor: "#1f2937",
              color: "#f9fafb",
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              fontFamily: 'Cambria, "Times New Roman", serif',
              width: '40%'
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handlehelpClose}
              sx={{ position: "absolute", top: 8, right: 8, color: "#f9fafb" }}
            >
              <CloseIcon />
            </IconButton>

            {/* Modal Content */}
            <Typography
              id="help-modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
            >
              Help Center
            </Typography>

            <Typography
              id="help-modal-description"
              sx={{
                fontSize: "14px",
                lineHeight: 1.8,
                color: "#f9fafb",
              }}
            >
              {/* Left-aligned Company Details */}
              <div style={{ textAlign: "left" }}>
                <strong>EFFTABS SOLUTIONS LLP</strong> <br />
                Address: Kunnath Lane, Palarivattom, Kochi, Kerala – 682025 <br />
                Phone: +91 484 405 4243 <br />
                Email: info@efftabs.com <br />
              </div>

              <br />

              {/* Centered Copyright */}
              <div style={{ textAlign: "center", color: "yellow", fontWeight: "bold" }}>
                Copyright © 2021. EFFTABS All rights reserved
              </div>
            </Typography>

          </Box>
        </Modal>

      </div>

    </div >
  );
};

export default Home;  
